module.exports = __webpack_public_path__ + "static/img/viewAv3.866067b9.png";